import styled from 'styled-components';

export const Container = styled.div`
	h2 {
		text-align: left;
	}
`;
export const Title = styled.h1`
	background-color: white;
	color: #4d4d4d;
	font-size: 1em;
	font-weight: 100;
	text-transform: uppercase;
	padding: 2px 0 11px 0;
	-webkit-box-shadow: 1px 4px 13px -9px rgba(0, 0, 0, 0.69);
	-moz-box-shadow: 1px 4px 13px -9px rgba(0, 0, 0, 0.69);
	box-shadow: 1px 4px 13px -9px rgba(0, 0, 0, 0.69);
	display: inline-block;
	width: 100%;
`;
export const BoxCestaIntegralizacao = styled.div`
	display: flex;
	justify-content: center;

	width: 100%;
	min-height: 600px;

	margin-bottom: 0px;

	background-image: url('/asset-management/etf-commodities/images/commodities-btg-pactual-composicao-cesta-integralizacao.jpg');
	background-size: cover;
	background-position: center;
`;
export const BoxCestaResgate = styled.div`
	display: flex;
	justify-content: center;

	width: 100%;
	min-height: 620px;

	background-image: url('/asset-management/etf-commodities/images/commodities-btg-pactual-composicao-cesta-resgate.jpg');
	background-size: cover;
	background-position: center;

	@media (max-width: 780px) {
		min-height: unset;
		background-image: none;
		justify-content: end;
		margin-top: 0;
	}
`;
export const BoxCarteira = styled.div`
	display: flex;
	justify-content: center;

	width: 100%;
	min-height: 500px;
`;
export const BoxEmprestimo = styled.div`
	display: flex;
	justify-content: center;

	width: 100%;
	min-height: 750px;

	background-image: url('/asset-management/etf-commodities/images/commodities-btg-pactual-emprestimo.jpg');
	background-size: cover;
	background-position: center;

	@media (max-width: 780px) {
		min-height: unset;
		background-image: none;
		background-color: var(--light-blue);
	}
`;
export const BoxComposicao = styled.div`
	display: flex;
	justify-content: center;

	width: 100%;
	min-height: 640px;

	background-image: url('/asset-management/etf-commodities/images/commodities-btg-pactual-composicao-indice.jpg');
	background-size: cover;
	background-position: top center;

	@media (max-width: 780px) {
		min-height: unset;
		background-image: none;
		justify-content: end;
		margin-top: 0;
	}
`;
export const ContentCestaIntegralizacao = styled.div`
	width: 90%;
	max-width: 1141px;

	padding: 80px 0;

	h2 {
		margin-bottom: 30px !important;
		color: var(--dark-blue);
	}

	img {
		max-width: 140px;
		margin-top: 60%;
	}

	@media (max-width: 780px) {
		padding-top: 30px;
		padding-bottom: 30px;

		img {
			margin-top: 0;
			margin-bottom: 30px;
			max-width: 110px;
		}

		.IntegralizacaoGrid {
			overflow-x: scroll;
			overflow-y: hidden;
		}
	}
`;
export const ContentCestaResgate = styled.div`
	width: 90%;
	max-width: 1141px;

	display: flex;
	justify-content: left;

	@media (max-width: 780px) {
		width: 100%;

		overflow-x: scroll;
		overflow-y: hidden;
	}
`;
export const ContentCarteira = styled.div`
	width: 90%;
	max-width: 1141px;
	min-height: 510px;

	padding: 60px 0px 0px 0px;

	h2 {
		margin-bottom: 30px !important;
		color: var(--dark-blue);
	}

	img {
		width: 100%;
		margin-top: 16%;
	}

	@media (max-width: 780px) {
		padding-top: 0;

		img {
			margin-top: 15px;
		}

		.CarteiraGrid {
			overflow-x: scroll;
			overflow-y: hidden;
		}
	}
`;
export const ContentEmprestimo = styled.div`
	width: 90%;
	max-width: 1141px;
	height: 600px;

	padding: 70px 0px 100px 0px;

	> h2 {
		color: var(--dark-blue);
	}

	@media (max-width: 780px) {
		height: 500px;

		padding-top: 30px;
		padding-bottom: 30px;

		overflow-x: scroll;
		overflow-y: hidden;

		> h2 {
			color: var(--white);
		}
	}
`;
export const ContentComposicao = styled.div`
	width: 90%;
	max-width: 1141px;
	height: 630px;

	display: flex;
	justify-content: flex-end;

	@media (max-width: 780px) {
		width: 100%;

		justify-content: end;
	}
`;


export const ImagemCarteira = styled.div`
	width: 320px;
	height: 320px;
	background-image: url('/asset-management/etf-commodities/images/commodities-btg-pactual-composicao-carteira-imagem.png');
	background-position: center;
	background-size: auto 100%;
	background-repeat: no-repeat;
	border-radius: 100%;
	margin: 50px 0 0 65px;
`;


export const BlockCestaIntegralizacao = styled.div`
	min-width: 100%;
	height: 100%;
	
`;
export const BlockCestaResgate = styled.div`
	background-color: var(--light-blue);

	width: 860px;
	padding: 40px;
	margin: -30px 0;

	> h2 {
		color: var(--white);
	}

	@media (max-width: 780px) {
		width: 100%;

		margin: 0;
		padding: 30px 15px;

		overflow-x: scroll;
		overflow-y: hidden;
	}
`;
export const BlockCarteira = styled.div`
	width: 100%;
	height: 350px;
`;
export const BlockComposicao = styled.div`
	background-color: var(--dark-blue);

	width: 720px;
	padding: 40px;
	padding-bottom: 60px;
	margin-top: -30px;

	> h2 {
		color: var(--white);
	}

	@media (max-width: 780px) {
		width: 100%;
		height: 500px;

		margin: 0;
		padding: 30px 15px;

		overflow-x: scroll;
		overflow-y: hidden;
	}
`;
export const Tabela = styled.div`
	min-width: 600px;
	width: 100%;
	height: 95%;
	max-height: 750px;

	margin-top: 20px;
	/* border: 1px solid var(--black); */

	@media (max-width: 780px) {
		height: 90%;
	}
`;

export const HoraAtualizacaoIntegralizacao = styled.div`

width: 83%;
display: flex;
justify-content: flex-end;
height:auto;
margin-top: -40px;

> h2 {
	min-width: 100px;
	color: darkblue;
	font-size: 14px;
	margin-top: unset;
	align: center;
}

img{
	width: unset;
	height:18px;
	z-index:0;
	margin-left: 5px;
	margin-top: unset;
}

`;



export const HoraAtualizacaoResgate = styled.div`

width: 80%;
display: flex;
justify-content: flex-end;
height:auto;
margin-top: -20px;

> h2 {
	min-width: 100px;
	color: white;
	font-size: 14px;
	align: center;
}

img{
	width: unset;
	height:18px;
	z-index:0;
	margin-left: 5px;
}

`;


export const HoraAtualizacaoCarteira = styled.div`

width: 77%;
display: flex;
justify-content: flex-end;
height:auto;
margin-top: 7px;

> h2 {
	min-width: 100px;
	color: darkblue;
	font-size: 14px;
	margin-top: 15px;
}

img{
	width: unset;
	height:18px;
	z-index:0;
	margin-left: 5px;
	margin-top: 15px;
}

`;

export const HoraAtualizacaoEmprestimo = styled.div`

width: 80%;
display: flex;
justify-content: flex-end;
height:auto;
margin-top: -20px;

> h2 {
	min-width: 100px;
	color: white;
	font-size: 14px;
	align: center;
}

img{
	width: unset;
	height:18px;
	z-index:0;
	margin-left: 5px;
}

`;

export const HoraAtualizacaoEmprestimo2 = styled.div`

width: 85%;
display: flex;
justify-content: flex-end;
height:auto;
margin-top: 10px;

> h2 {
	min-width: 100px;
	color: darkblue;
	font-size: 14px;
	margin-top: 20px;
}

img{
	width: unset;
	height:18px;
	z-index:0;
	margin-left: 5px;
	margin-top: 20px;
}

`;

export const HoraAtualizacao = styled.div`

width: 65%;
display: flex;
justify-content: flex-end;
height:auto;
margin: 0px 0px 0px 0px;
margin-top: 15px;

> h2 {
	min-width: 100px;
	color: var(--darkblue);
	font-size: 14px;
	margin-top: unset;
}

img{
	width: unset;
	height:16px;;
	z-index:0;
	margin-left: 5px;
	margin-top: unset;
}

`;
